import { Outlet, useLocation } from 'react-router-dom';
import ToolsBreadcrumb from '../common/components/ToolsBreadcrumb';
import Upgrade from './pages/Upgrade';
import Wizard from './components/Wizard';

function ProrogateOrUpgrade() {
  const { pathname } = useLocation();
  const isRoot =
    pathname === '/prorogate-or-upgrade' ||
    pathname === '/prorogate-or-upgrade/';
  const isPaymentPage = pathname.includes('/payment');

  return (
    <div>
      <ToolsBreadcrumb
        parentName="خرید طرح"
        parentUrl="/prorogate-or-upgrade/"
        childs={[]}
      />
      {isRoot ? (
        <Upgrade hideFooter />
      ) : isPaymentPage ? (
        <Outlet />
      ) : (
        <Wizard variant="" progressBar />
      )}
    </div>
  );
}

export default ProrogateOrUpgrade;
